// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"be9d88b1","455":"5bcf3029","977":"1cf408b4"}[chunkId] + ".chunk.js";
};